import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';

const StyledInput = styledComponent('input', {
  padding: theme.spacing.inputPadding,
  border: theme.borders.input,
  borderRadius: theme.radii.input,
  ...theme.typography.label,
  color: theme.colors.textBody,
  width: '100%',
  boxSizing: 'border-box',
  transition: theme.transitions.default,
  '&:hover': {
    borderColor: theme.colors.infoBlue,
  },
  '&:focus': {
    outline: 'none',
    borderColor: theme.colors.infoBlue,
    boxShadow: `0 0 0 2px ${theme.colors.infoBlue}33`,
  },
  '&[readonly]': {
    background: theme.colors.bgMuted,
    color: theme.colors.textMuted,
  },
  '&:disabled': {
    background: theme.colors.bgMuted,
    color: theme.colors.textMuted,
    cursor: 'not-allowed',
  },
});

function Input({
  id,
  type,
  value,
  onChange,
  placeholder,
  min,
  step,
  readOnly,
  disabled,
  style,
  dataTestId,
  'aria-label': ariaLabel,
  'aria-required': ariaRequired,
}) {
  return (
    <StyledInput
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      min={min}
      step={step}
      readOnly={readOnly}
      disabled={disabled}
      style={style}
      data-testid={dataTestId}
      aria-label={ariaLabel}
      aria-required={ariaRequired}
    />
  );
}

Input.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  min: PropTypes.string,
  step: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  dataTestId: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-required': PropTypes.bool,
};

Input.defaultProps = {
  id: undefined,
  type: 'text',
  value: undefined,
  onChange: undefined,
  placeholder: undefined,
  min: undefined,
  step: undefined,
  readOnly: false,
  disabled: false,
  style: undefined,
  dataTestId: undefined,
  'aria-label': undefined,
  'aria-required': undefined,
};

export default Input;
